import { CrossMarketRoute } from '../types/cross-market-route';
import { ShippingFeeBreakdown } from '../types/shipping-fee-breakdown';

/**
 * Show shipping fee component if there's a cross market fee and/or there's a
 * destination fee.
 *
 * @param crossMarketRoute - The cross market route.
 * @param shippingFeeBreakdown - The shipping fee breakdown.
 * @returns True if the shipping fee should be shown, false otherwise.
 */
export default function shouldShowShippingFee(
  crossMarketRoute?: CrossMarketRoute,
  shippingFeeBreakdown?: ShippingFeeBreakdown
) {
  return (
    crossMarketRoute?.fee !== undefined ||
    (shippingFeeBreakdown !== undefined && shippingFeeBreakdown.total_shipping_fee > 0)
  );
}
